module.exports = require("@trendmicro/react-dropdown");


//////////////////
// WEBPACK FOOTER
// external "@trendmicro/react-dropdown"
// module id = 4
// module chunks = 0